
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'setup-an-action',
	title: 'Setting up an action'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "webhooks/setup-an-action",
  "id": "webhooks/setup-an-action",
  "isDocsHomePage": false,
  "title": "Setting up an action",
  "description": "Set up an action",
  "source": "@site/docs/webhooks/setup-an-action.md",
  "sourceDirName": "webhooks",
  "slug": "/webhooks/setup-an-action",
  "permalink": "/docs/webhooks/setup-an-action",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "setup-an-action",
    "title": "Setting up an action"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Selecting relevant policy events",
    "permalink": "/docs/webhooks/select-events"
  },
  "next": {
    "title": "Monitor API Traffic",
    "permalink": "/docs/webhooks/monitor-api-traffic"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p><img alt={"Set up an action"} src={require("!url-loader?limit=10000&name=assets/images/[name]-[hash].[ext]&fallback=file-loader!./setup-an-action.png").default} /></p>
    <p>{`If a system is not in the library of pre-built integrations, a webhook is the default way to share information.
Authentication is built-in so that communication is secured. Add as many actions as needed to share data with external systems.`}</p>
    <p>{`A webhook can be an existing service or a small piece of custom-built code. It performs any custom logic needed such as
transforming data to custom formats and creating the policy within the policy system.`}</p>
    <p>{`Webhooks can be used to connect to:`}</p>
    <ul>
      <li parentName="ul">{`Rating systems`}</li>
      <li parentName="ul">{`Policy systems`}</li>
      <li parentName="ul">{`Marketing automation systems`}</li>
      <li parentName="ul">{`CRM systems`}</li>
      <li parentName="ul">{`Data lakes`}</li>
      <li parentName="ul">{`And more...`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
